// extracted by mini-css-extract-plugin
export default {"fixedHeight":"PackagesSearchControlsGCWrapper_fixedHeight__NzJkZ"};